import React, { Component } from "react";
import { connect } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
// import Checkbox from "@material-ui/core/Checkbox";
import history from "../Utils/History";
import MenuIcon from "@material-ui/icons/Menu";
import {
  NEBRASKA_CONSTS,
  SHARP_CONSTS,
  contactInfo,
} from "../Utils/StaticData/Constant";
import {
  comparePlan,
  getcmpNames,
  setFormData,
  setStateParams,
} from "../Redux/Actions/webAppActions";
import { Text } from "react-internationalization";
import { LANG } from "./translations/dynamic";
import SalesMaterial from "./SalesMaterial";

const CustomRadio = withStyles({
  root: {
    height: "30px",
    textAlign: "left",
  },
})(Radio);
const CustomRadioGroup = withStyles({
  root: {
    display: "inline",
    marginLeft: "0",
  },
})(RadioGroup);
const CustomFormControlLabel = withStyles({
  root: {
    width: "250px",
    marginLeft: "14px",
    marginRight: "0px",
    textAlign: "left",
  },
})(FormControlLabel);

const CustomRadioFormLabel = withStyles((theme) => ({
  root: {
    width: "135px",
  },
}))(FormControlLabel);

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      plans: [
        {
          name: "Medicare Advantage + Prescription Drug",
          value: "MAPD",
        },
        {
          name: "Medicare Advantage Only",
          value: "MA",
        },
        {
          name: "Medicare Part D",
          value: "PDP",
        },
        {
          name: "Medicare Supplement",
          value: "Medicare Supplement",
        },
      ],
      categories: [
        {
          name: "Individual",
          value: "INDIVIDUAL",
        },
        {
          name: "Group",
          value: "GROUP",
        },
        {
          name: "Retiree",
          value: "RETIREE",
        },
      ],
      planIds: [],
      types: ["HMO", "PPO"],
      selectedPlan: this.props.selectedProduct,
      selectedType: this.props.planType ?? "",
      price: "",
      planSelected: false,
      productTypeSelected: this.props.selectedProduct,
      sliderInitial: "50",
      county: this.props.county,
      // comparePlans: this.props.compareList,
    };
  }
  componentDidUpdate(prevState, prevProps) {
    if (
      prevState.zipCode != this.props.zipCode ||
      prevState.county != this.props.county
    ) {
      this.setState({
        selectedPlan: "",
        selectedType: "",
        price: "",
        productTypeSelected: "",
        planSelected: false,
      });
      this.props.handleReset();
      this.props.setStateParams("selectedProduct", "");
    }
  }
  compare = async (event) => {
    //to be sent to api as request if compare is clicked.
    let plans = [];

    plans = this.props.cardDetails.filter(
      (card) => this.props.compareList.indexOf(card.productId) >= 0
    );

    if (plans.length === 1) {
      let formPayload = {
        planId: plans[0].planId,
        productId: plans[0].productId,
        premiumAmount: plans[0].monthlyPremium,
        // planName: plans[0].planName,
        planName:
          this.props.lang === "es" && plans[0].planNameES
            ? plans[0].planNameES
            : plans[0].planName.toUpperCase(),
      };
      this.props.setFormData(formPayload);
    }
    this.props.getcmpNames(plans);
    window.sessionStorage.setItem("cmpnames", JSON.stringify(plans));
    const list = plans.map((plan) => ({
      customerId: this.props?.customerId,
      planId: plan.planId,
      productId: plan.productId,
      //planName: plan.planName,
      planName:
        this.props.lang === "es" && plan.planNameES
          ? plan.planNameES
          : plan.planName.toUpperCase(),
      planYear: this.props.year,
    }));
    await this.props.comparePlan(list);
    window.sessionStorage.setItem(
      "selectedPlansForCompare",
      JSON.stringify(this.props.selectedPlansForCompare)
    );
    history.push("/e-Enroll/compare-plan");
  };
  reset = async (e) => {
    e.preventDefault();
    document.getElementById("price").value = 50;
    //to be sent to api as request if compare is clicked.
    // let payload = {
    //   plansSelected: this.props.compareList,
    // };
    await this.setState({
      selectedPlan: "",
      selectedType: "",
      price: "",
      sliderInitial: "50",
      productTypeSelected: "",
      planSelected: false,
    });

    this.props.handleReset();
    this.props.setStateParams("selectedProduct", "");
    this.props.setStateParams("planType", "");
  };

  handleChange = async (event, id) => {
    this.props.handleReset2();
    const value = event.target ? event.target.value : event.value;
    if (id === "planSelect") {
      this.props.removeCompareList();
      this.props.handleFilter("productFilter", value);
      this.props.setStateParams("selectedProduct", value);
      this.props.setStateParams("selectedPlansForCompare", []);
      this.props.handleFilter("planTypeFilter", "");
      this.props.setStateParams("planType", "");
      await this.setState({
        selectedPlan: value,
        planSelected: true,
        productTypeSelected: value,
        selectedType: "",
      });
    } else if (id === "plan_type") {
      this.props.handleFilter("planTypeFilter", value);
      this.props.setStateParams("planType", value);
      await this.setState({
        selectedType: value,
      });
    } else {
      this.props.handleFilter("premiumFilter", value);
      await this.setState({
        price: value,
      });
    }
  };
  componentDidMount() {
    if (this.props.planType) {
      this.setState({ ...this.state, planSelected: true });
    }
    if (
      this.props.lang === "es" &&
      this.props.customerId !== SHARP_CONSTS.SHARP_CUSTOMER_ID
    ) {
      this.setState({
        ...this.state,
        plans: [
          {
            name: "Ventaja de Medicare + medicamento recetado",
            value: "MAPD",
          },
          {
            name: "Solo ventaja de Medicare",
            value: "MA",
          },
          {
            name: "Parte D de Medicare",
            value: "PDP",
          },
          {
            name: "Suplemento de Medicare",
            value: "Medicare Supplement",
          },
        ],
      });
    }
  }
  render() {
    let {
      // value,
      plans,
      categories,
      selectedPlan,
      // types,
      selectedType,
      price,
      planSelected,
      productTypeSelected,
    } = this.state;
    if (this.props.customerId === "HCF0331") {
      plans = categories.map((cat) => {
        if (this.props.lang === "es") {
          cat.name = LANG.CATEGORY[cat.value];
        }
        return cat;
      });
    }
    let planIdList = [];
    this.props.cardDetails.forEach((card, i) => {
      planIdList.push(card.planId);
    });

    const { compareList } = this.props;

    let types1 = ["HMO", "PPO"];
    let types2 = ["HMO", "PPO"];
    let types3 = ["Basic", "Enhanced"];
    let typesInitial = [];
    let typesSupplement = [];
    let types4 = ["A", "B"];
    let types5 = ["F", "G"];

    this.props.cardDetails.forEach((card, i) => {
      typesInitial.push(card.planType);
    });
    typesInitial.forEach((type, i) => {
      type.includes("Plan") && typesSupplement.push(type);
    });
    // console.log("test-",this.props.selectedProduct)
    return (
      <div>
        <div class="head-slide sidebar-fontcolor">
          <Text id="app.product" />
        </div>
        <div class="nav-sidebar">
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Plans"
              name="PlanSelect"
              id="planSelect"
              class="sidebar-fontcolor2 text-align-start"
              value={selectedPlan}
              onChange={(e) => {
                this.handleChange(e, "planSelect");
              }}
            >
              {plans.map((plan) => (
                <CustomFormControlLabel
                  value={plan.value}
                  control={<CustomRadio color="primary" />}
                  label={plan.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </div>
        {planSelected === true && (
          <div class="head-slide sidebar-fontcolor">
            {" "}
            <Text id="app.plantype" />
          </div>
        )}
        <div class="nav-sidebar">
          {planSelected === true && (
            <FormControl component="fieldset">
              <CustomRadioGroup
                aria-label="plan_type"
                name="plan_type"
                id="plan_type"
                class="sidebar-fontcolor2"
                value={selectedType}
                onChange={(e) => {
                  this.handleChange(e, "plan_type");
                }}
              >
                {productTypeSelected === "GROUP" ||
                productTypeSelected === "RETIREE" ||
                productTypeSelected === "INDIVIDUAL"
                  ? types1.pop() &&
                    types1.map((type) => (
                      <CustomRadioFormLabel
                        value={type}
                        control={<CustomRadio color="primary" />}
                        label={type}
                      />
                    ))
                  : ""}
                {productTypeSelected === "MAPD" &&
                  types1.map((type) => (
                    <CustomRadioFormLabel
                      value={type}
                      control={<CustomRadio color="primary" />}
                      label={type}
                    />
                  ))}{" "}
                {productTypeSelected === "MA" &&
                  types2.map((type) => (
                    <CustomRadioFormLabel
                      value={type}
                      control={<CustomRadio color="primary" />}
                      label={type}
                    />
                  ))}
                {productTypeSelected === "PDP" &&
                  types3.map((type) => (
                    <CustomRadioFormLabel
                      value={type}
                      control={<CustomRadio color="primary" />}
                      label={type}
                    />
                  ))}
                {productTypeSelected === "Medicare Supplement" &&
                  (typesSupplement.includes("Plan A") ||
                    typesSupplement.includes("Plan B")) &&
                  types4.map((type) => (
                    <CustomRadioFormLabel
                      value={type}
                      control={<CustomRadio color="primary" />}
                      label={type}
                    />
                  ))}
                {productTypeSelected === "Medicare Supplement" &&
                  (typesSupplement.includes("Plan F") ||
                    typesSupplement.includes("Plan G")) &&
                  types5.map((type) => (
                    <CustomRadioFormLabel
                      value={type}
                      control={<CustomRadio color="primary" />}
                      label={type}
                    />
                  ))}
              </CustomRadioGroup>
            </FormControl>
          )}
        </div>
        <div class="head-slide sidebar-fontcolor">
          <Text id="app.filterby" />
        </div>
        <div class="slidecontainer">
          <p class="mb-0 text-left sidebar-fontcolor2">
            <Text id="app.premium" />{" "}
            <span class="float-right">
              ${price.length > 0 ? price : this.state.sliderInitial}
            </span>
          </p>
          <input
            id="price"
            type="range"
            class="slider"
            min="0"
            max="146"
            defaultValue={this.state.sliderInitial}
            onChange={(e) => {
              this.handleChange(e, "price");
            }}
          />
        </div>
        <button
          class={"btn-primary-reset"}
          // disabled={this.props.compareList.length > 0 ? false : true}
          onClick={this.reset}
        >
          {/* <p class="mb-0 sidebar-fontcolor2">Reset Filter</p> */}
          <Text id="app.rfilter" />
        </button>
        <div class="head-slide sidebar-fontcolor">
          <Text id="app.compare" />
        </div>
        <div class="nav-sidebar">
          {planIdList.map((planId, i) => {
            // <CustomCheckboxFormLabel
            //   className={"form-checkbox"}
            //   control={
            //     <CustomCheckbox
            //       checked={this.props.compareList.indexOf(planId) !== -1}
            //       value={planId}
            //       inputProps={{
            //         "aria-label": "primary checkbox",
            //       }}
            //       color="primary"
            //       disabled="true"
            //     />
            //   }
            //   label={this.props.cardDetails[i].name}
            // />
            return (
              <div>
                {compareList.indexOf(planId) !== -1 ? (
                  <p class="compare-plans  sidebar-fontcolor2">
                    {this.props.cardDetails[i].name}
                  </p>
                ) : (
                  ""
                )}
              </div>
            );
          })}

          {compareList.length === 0 ? (
            <p class="compare-plans sidebar-fontcolor2">
              {" "}
              <Text id="app.psptc" />
            </p>
          ) : (
            <>
              {this.props.cardDetails
                .filter(
                  (card) => this.props.compareList.indexOf(card.productId) >= 0
                )
                .map((plan) => (
                  <p className="compare-plans  sidebar-fontcolor2">
                    {this.props.lang === "es" && plan.planNameES
                      ? plan.planNameES
                      : plan.planName.toUpperCase()}
                  </p>
                ))}
            </>
          )}

          <div class="text-center">
            <button
              class={
                this.props.compareList.length > 1
                  ? "btn-primary-continue mb-5 compare-btn-pading"
                  : "btn-primary-continue mb-5 btn-disable-sideBar compare-btn-pading"
              }
              disabled={this.props.compareList.length > 1 ? false : true}
              onClick={this.compare}
            >
              <p class="mb-0">
                <Text id="app.compare" />
              </p>
            </button>
          </div>
        </div>
        {
          this.props.agentLogin === true && SalesMaterial(this.props.customerId)
          // <SalesMaterial
          // customerId={this.props.customerId}
          // />
        }
        <div
          className={
            this.props.clicked
              ? "phone-button display-flex flex-row phone-button-pad"
              : "phone-button display-flex flex-row"
          }
        >
          <a
            href={
              "tel:" +
              contactInfo(this.props.customerId, this.props.agentLogin).tel
            }
            className="button1"
            title={
              this.props.customerId === NEBRASKA_CONSTS.ID
                ? "Broker Support"
                : ""
            }
          >
            <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;
            {/* {this.props.customerId === "HCF0331"
              ? "(855) 562-8853"
              : "(877) 833-3499"} */}
            {contactInfo(this.props.customerId, this.props.agentLogin).phNum}
          </a>

          {/* <ChevronLeftSharpIcon style={{color:"white",cursor:"pointer"}} /> */}
          {/* <span class=" btn-toggle-text ml-2">Toggle Sidebar</span> */}
          <a
            class="btn btn-sidebaricon-hide2 btn-toggle justify-content-center btn-toggle1"
            onClick={this.props.toggle}
          >
            <MenuIcon />
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    agentLogin: state.login.agentLoggedIn,
    county: state.webApp.county,
    customerId: state.login.customerId,
    selectedProduct: state.webApp.selectedProduct,
    lang: state.webApp.language,
    planType: state.webApp.planType,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
  };
};
const mapDispatchToProps = {
  comparePlan,
  getcmpNames,
  setFormData,
  setStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
